export const chiaveSessione = (username, azione) => `MAG:${username}:${azione}`;
export const haCoda = value => Boolean(value?.queue?.length || value?.pending);

export function salvaSessioneLocale(storage, username, sessione, value) {
  const key=chiaveSessione(username,sessione.azione);
  const precedente=JSON.parse(storage.getItem(key)||"null");
  if(precedente && precedente.sessione!==sessione.id && haCoda(precedente)) {
    throw new Error("Completa le letture locali della precedente sessione prima di sostituirla.");
  }
  storage.setItem(key,JSON.stringify({sessione:sessione.id,...value}));
  storage.removeItem(`MAG:${username}:${sessione.id}`);
  // Elimina soltanto le vecchie code vuote del medesimo utente.
  // Le code legacy non inviate restano recuperabili tramite la loro sessione.
  const prefix=`MAG:${username}:`;
  const keys=Array.from({length:storage.length},(_,i)=>storage.key(i));
  for(const oldKey of keys) {
    if(!oldKey?.startsWith(prefix) || ["TROVATO","PRONTO"].includes(oldKey.slice(prefix.length))) continue;
    try { if(!haCoda(JSON.parse(storage.getItem(oldKey)))) storage.removeItem(oldKey); }
    catch (_) { /* Dati legacy non leggibili conservati per il recupero. */ }
  }
}

export function leggiSessioneLocale(storage, username, sessione) {
  const saved=JSON.parse(storage.getItem(chiaveSessione(username,sessione.azione))||"null");
  const legacy=JSON.parse(storage.getItem(`MAG:${username}:${sessione.id}`)||"null");
  const value=saved?.sessione===sessione.id ? saved : legacy || {queue:[],pending:null};
  return {queue:value.queue||[],pending:value.pending||null};
}

export function statoLetturaAtteso(u,letture,pending,azione) {
  const barcode=u.presentazione?.barcode_matricola;
  if(barcode && pending?.barcode===barcode) return "In attesa articolo";
  const lettura=letture.slice().reverse().find(l=>l.metodo!=="MANUALE" &&
    (barcode ? l.barcode===barcode : l.id_unita===u.id));
  if(lettura) return lettura.confermata ? "Confermata" : ["VALIDA","FUORI_ATTESI"].includes(lettura.esito) ? "Letta · da confermare" : "Lettura da verificare";
  return u.corrente?.coerente && u.corrente?.metodo==="SCANSIONE" && (azione==="TROVATO" ? ["TROVATO","PRONTO"].includes(u.corrente.stato) : u.corrente.stato==="PRONTO") ? "Confermata" : "";
}
